import React, { useEffect, useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import {
  PromptHeaderContainer,
  PromptHeaderLeftContainer,
  PromptHeaderRightContainer,
  IconContainer,
} from "./PromptHeader.styled";
import { Button, Icon, Typography, Alert } from "@ann/web-components";
import { useParams} from 'react-router-dom';
import { usePromptFormContext } from "../../context/PromptFormContext";
import { createPrompt } from "../../../../../services";
import { useStore } from "../../../../../hooks";
import { observer } from "mobx-react";


const PromptHeader = observer(({ promptData }) => {
  const navigate = useNavigate();
  const { authStore } = useStore();
  const tenantId = authStore.currentWorkspaceUuid
  const location = useLocation();
  const [showAlert, setShowAlert] = useState(false);
  const [description, setDescription] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const [alert, setAlert] = useState(null);
  const { promptId } = useParams();  

  const [isEditMode, setIsEditMode] = useState(false);

  useEffect(() => {
    if (promptId !== 'new') {
      setIsEditMode(true);
    }
  }, [promptId]);



  const { 
    formData, 
    isFormValid, 
    handleSubmit,
    resetForm 
  } = usePromptFormContext();

  const handleClose = () => {
    setShowAlert(false);
    setAlert(null);
  };

  const handleSave = async () => {
    const isValid = handleSubmit();
    if (isValid) {
      setIsLoading(true);
      
      const dataToSend = {
        tenantId,
        name: formData.name,
        description: formData.description,
        categories: [
          "string"
        ],
        tags:[
          "string"
        ],
        llmModel: 'gpt-4-turbo',
        promptText: formData.instructions,
        isPublic: false,
        scope: "internal"
      }
      try {
        const response = await createPrompt(dataToSend);
        setIsLoading(false);
        setDescription("The prompt was successfully saved");
        setShowAlert(true);
        setAlert({
          title: "All set!",
          message: "Your prompt has been created and is ready to use.",
          severity: "success"
        });
        
        setTimeout(() => {
          navigate("/v2/pms");
        }, 2000);
      } catch (error) {
        setIsLoading(false);
        setDescription("Error creating prompt");
        setShowAlert(true);
        setAlert({
          title: "Prompt not created",
          message: "There was an issue saving your prompt. Check your inputs and try again.",
          severity: "error"
        });
      }
    } else {
      setDescription("Please fill in all required fields correctly");
      setShowAlert(true);
      setAlert({
        title: "Form incomplete",
        message: "Please fill in all required fields correctly.",
        severity: "error"
      });
    }
  };

  const handleCreateOrPublish = async () => {
    const isValid = handleSubmit();
    if (isValid) {
      setIsLoading(true);
      const dataToSend = {
        tenantId,
        name: formData.name,
        description: formData.description,
        categories: [
          "string"
        ],
        tags:[
          "string"
        ],
        llmModel: 'gpt-4-turbo',
        promptText: formData.instructions,
        isPublic: false,
        scope: "internal"
      }
      try {
        const response = await createPrompt(dataToSend);
        
         if (isVersionPage) {
          setAlert({
            title: "All set!",
            message: "Your prompt has been created and is ready to use.",
            severity: "success"
          });
        } else {
          setDescription("The prompt was successfully created");
          setAlert({
            title: "All set!",
            message: "Your prompt has been created and is ready to use.",
            severity: "success"
          });
          
          setTimeout(() => {
            navigate("/v2/pms");
          }, 2000);
        }
        setShowAlert(true);
        setTimeout(() => {
          navigate('/v2/pms');
        }, 3000);
      } catch (error) {
        setIsLoading(false);
        setDescription("Error creating prompt");
        setShowAlert(true);
        setAlert({
          title: "Prompt not created",
          message: "There was an issue saving your prompt. Check your inputs and try again.",
          severity: "error"
        });
      }
      
    } else {
      setIsLoading(false);
      setDescription("Please fill in all required fields correctly");
      setShowAlert(true);
      setAlert({
        title: "Form incomplete",
        message: "Please fill in all required fields correctly.",
        severity: "error"
      });
    }
  };

 
  const isVersionPage = location.pathname.includes('/versions');

  return (
    <>
      <PromptHeaderContainer>
        <PromptHeaderLeftContainer>
          <IconContainer onClick={() => navigate("/v2/pms")}>
            <Icon name="arrowLeft" size="medium" />
          </IconContainer>
          <Typography category="title" size="medium" weight="bold">
            {promptData?.name || "New Prompt"}
          </Typography>
        </PromptHeaderLeftContainer>
        <PromptHeaderRightContainer>
          {
            /*<Button
              onClick={handleSave}
              type="secondary"
              size="medium"
              label="Save"
              disabled
            />*/
          }
          {!isVersionPage ? (
            isEditMode ? (
             <Button
                variant="primary"
                size="medium"
                label="Publish"
                disabled={true}
              />
            ) : (
              <Button
                onClick={handleCreateOrPublish}
                variant="primary"
                size="medium"
                label="Publish"
                disabled={!isFormValid() || isLoading}
              />
            )
          ) : (
            <Button
              onClick={handleCreateOrPublish}
              variant="primary"
              size="medium"
              label="Publish"
              disabled
            />
          )}
        </PromptHeaderRightContainer>

      </PromptHeaderContainer>

      {alert && (
        <Alert
          title={alert.title}
          description={alert.message}
          severity={alert.severity}
          width={"692px"}
          top={"61px"}
          right={"16px"}
          closable={true}
          autoClose={true}
          autoCloseDelay={3000}
          onClose={handleClose}
        />
      )}
    </>
  );
});

export default PromptHeader;
